import { render, staticRenderFns } from "./BannerText.vue?vue&type=template&id=53746dec&scoped=true&"
import script from "./BannerText.vue?vue&type=script&lang=js&"
export * from "./BannerText.vue?vue&type=script&lang=js&"
import style0 from "./BannerText.vue?vue&type=style&index=0&id=53746dec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53746dec",
  null
  
)

export default component.exports